import { Component, OnInit, Input, Inject, Optional, ViewChild, ElementRef, Renderer2, AfterViewInit } from '@angular/core';

import * as Tokens from '@shared/core/tokens';

@Component({
    selector: 'shared-card-visualizer',
    templateUrl: './card-visualizer.shared.component.html',
    styleUrls: ['./card-visualizer.shared.component.scss']
})
export class CardVisualizerComponent implements OnInit, AfterViewInit {
    @Input() public cardNumber: string = ``;
    @Input() public label: string = 'MEMBER CARD';
    @ViewChild('digits', { static: true }) public digitsElementRef: ElementRef;
    @ViewChild('card', { static: true }) public card: ElementRef;

    constructor(
        @Optional() @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
        @Optional() public renderer2: Renderer2,
    ) { }

    ngOnInit(): void {
        if (
            this.config
            && this.config.memberCard
            && this.config.memberCard.maxLength
            && this.digitsElementRef
            && this.digitsElementRef.nativeElement
            && this.renderer2
        ) {
            // That was a bad idea... overwriting global css variables
            // const htmlStyles: CSSStyleDeclaration = window.getComputedStyle(document.querySelector('html'));
            // document.documentElement.style.setProperty('--card-visualizer-columns', `${this.config.memberCard.maxLength}`);
            const cols: number = this.config.memberCard.maxLength;
            this.renderer2.setStyle(this.digitsElementRef.nativeElement, `grid-template-columns`, `repeat(${cols + 1}, calc(100% / ${cols + 1}))`);
        }
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            if (this.card?.nativeElement) {
                /*
                    Safari is to dumb to calculate height dimension based on relative units like % -
                    FR units won't work in grid-template-rows unless non-relative value is set explicitly
                */
                this.renderer2.setStyle(this.card.nativeElement, 'height', this.card.nativeElement.clientHeight + 'px');
            }
        }, 0);
    }
}
